"use client";

import React from "react";
import {useMediaQuery} from "@mui/material";
import {ColletteCarousel} from "@collette-travel/collette-common-controls";
import { RelatedPostCard } from "../RelatedPostCard";
import styles from "./related-blogs-carousel.module.css";

export interface RelatedBlogsCarouselProps {
  posts: Array<{
    slug: string;
    title: string;
    imageUrl: string;
    imageAlt?: string;
    date: string;
  }>;
}

const RelatedBlogsCarousel: React.FC<RelatedBlogsCarouselProps> = ({
  posts
}) => {
  const isLg = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  const shouldEnableCarousel = isLg ? posts.length > 3 : posts.length > 2;

  // eslint-disable-next-line no-nested-ternary
  const arrowPosition = shouldEnableCarousel
    ? isLg
      ? "sides"
      : "bottom"
    : "none";

  const slides = posts.map((post) => (
    <RelatedPostCard
      key={post.slug}
      slug={post.slug}
      title={post.title}
      imageUrl={post.imageUrl}
      imageAlt={post.imageAlt}
      date={post.date}
    />
  ));

  return (
    <div className={styles.carouselWrapper}>
      <ColletteCarousel
        testId="related-blogs"
        variant="multi-card"
        arrowPosition={arrowPosition}
        showDots={shouldEnableCarousel && isLg}
        slidesToScroll="auto"
        spacing={26}
      >
        {slides}
      </ColletteCarousel>
    </div>
  );
};

export default RelatedBlogsCarousel; 